export * from './chart-simple.component';
export * from './chart-smallpie.component';
export * from './chart-simple.module';



// WEBPACK FOOTER //
// ./src/app/typescripts/pro/easy-charts/index.ts